import React, {useRef, useState, useEffect, useContext} from 'react';
import styled, {keyframes} from 'styled-components';
import {slideOutRight, slideInRight} from 'react-animations';
import * as Yup from 'yup';
import './styles.scss';
import fileDownload from 'js-file-download';
import {normalizeCollectionData} from '../../../utils/utils';
import {DataContext} from '../../../utils/DataProvider';
import {useInitialRenderEffect} from '../../../utils/functions';
import {fetchHarvests} from '../../../services/harvests';
import {fetchFarmsDetails} from '../../../services/farmsDetails';
import GenerateForm from '../../GenerateForm';
import Alert from '../../Notification';
import {fetchRegions} from '../../../services/regions';
import {fetchBenchmarkingPDF} from '../../../services/benchmark';

const FilterBenchmarkingDairy = () => {
  const {state} = useContext(DataContext);
  const ENVS = state.environment === 'dairy' ? 'DAIRY_CATTLE' : 'BEEF_CATTLE';
  const ref = useRef(null);
  const [regions, setRegions] = useState([]);
  const [harvests, setHarvests] = useState([]);
  const [farms, setFarms] = useState([]);
  const [hasFarms, setHasFarms] = useState(true);

  const [dataForm, setDataForm] = useState({via: false, individual: false});

  const loadRegion = async () => {
    try {
      const {data} = await fetchRegions();
      setRegions(data.resultList || []);
    } catch (e) {
      console.error(e);
    }
  };

  const loadHarvests = async () => {
    try {
      const {data} = await fetchHarvests();
      setHarvests(data.resultList || []);
    } catch (e) {
      console.error(e);
    }
  };

  const loadFarms = async (params = {}) => {
    try {
      const {data} = await fetchFarmsDetails({
        ...params,
        environment: 'DAIRY_CATTLE',
      });
      const farmsDetail = data.resultList.filter((farmDetail) => farmDetail.name || farmDetail.farm.name).map((farmDetail) => farmDetail.farm);
      setFarms(farmsDetail || []);

      if (farmsDetail.length) {
        setHasFarms(true);
      } else {
        setHasFarms(false);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useInitialRenderEffect(() => {
    loadHarvests();
    loadRegion();
  });

  useEffect(() => {
    if (dataForm.harvest) {
      loadFarms({'wherein[harvest.id]': dataForm.harvest});
    }
  }, [dataForm.harvest]);

  const groupFields = [
    {
      name: '',
      fields: [
        {
          label: 'Safra',
          name: 'harvest',
          type: 'autocomplete',
          hasPlaceholder: true,
          placeholder: 'Selecione a safra',
          value: harvests.length ? dataForm.harvest : '',
          required: true,
          // disabled: disableFields.harvest,
          validations: {
            harvest: Yup.string().required('Campo obrigatório'),
          },
          onChange: (data) => {
            setDataForm((prev) => ({...prev, harvest: data?.value}));
          },
          options: normalizeCollectionData(harvests, [
            {alias: 'label', key: 'title'},
            {alias: 'value', key: 'id'},
          ]),
          columns: {
            xs: 12,
          },
        },
        {
          label: 'Fazenda',
          name: 'farm',
          type: 'autocomplete',
          hasPlaceholder: true,
          placeholder: 'Selecione a fazenda',
          value: harvests.length ? dataForm.farm : '',
          // required: false,
          disabled: dataForm.region,
          // validations: {
          //   farm: !dataForm?.region && Yup.string().required('Campo obrigatório'),
          // },
          onChange: (data) => {
            setDataForm((prev) => ({...prev, farm: data?.value}));
          },
          options: normalizeCollectionData(farms, [
            {alias: 'label', key: 'name'},
            {alias: 'value', key: 'id'},
          ]),
          columns: {
            xs: 12,
          },
        },
        {
          hideField: false,
          label: 'Região',
          name: 'region',
          type: 'autocomplete',
          hasPlaceholder: true,
          placeholder: 'Selecione a Região',
          value: dataForm?.region || '',
          disabled: dataForm.farm,
          // validations: {
          //   region: !dataForm?.farm && Yup.string().required('Campo obrigatório'),
          // },
          onChange: (data) => {
            setDataForm((prev) => ({...prev, region: data?.value}));
          },

          options: normalizeCollectionData(regions, [
            {alias: 'label', key: 'title'},
            {alias: 'value', key: 'id'},
          ]),
          columns: {
            xs: 12,
          },
        },
        {
          hideField: false,
          label: 'INDIVIDUAL',
          name: 'individual',
          type: 'checkbox',
          value: dataForm.individual,
          className: 'Via-checkbox',
          //key: dataForm.customer,
          required: true,
          // disabled: !hasFarms || !dataForm.customer || !dataForm.harvest,
          onChange: (checked) => {
            setDataForm((prev) => ({...prev, individual: !!checked}));
          },
          columns: {
            xs: 6,
          },
        },
        {
          hideField: false,
          label: 'VIA',
          name: 'via',
          type: 'checkbox',
          value: dataForm.via,
          className: 'Via-checkbox',
          //key: dataForm.customer,
          required: true,
          // disabled: !hasFarms || !dataForm.customer || !dataForm.harvest,
          onChange: (checked) => {
            setDataForm((prev) => ({...prev, via: !!checked}));
          },
          columns: {
            xs: 6,
          },
        },
      ],
    },
  ];

  const fetchData = async (values) => {
    if(values.via === undefined) {
      values.via=false;
    }
    if(values.individual === undefined) {
      values.individual=false;
    }
    try {
      const endpoint = fetchBenchmarkingPDF;
      const extension = 'pdf';

      const response = await endpoint(
        {
          environment: ENVS,
          ...(values?.farm && {farm_ids: values?.farm}),
          harvest_id: values?.harvest,
          ...(values?.individual !== undefined && { individual: !!values?.individual }),
          ...(values?.via !== undefined && { via: !!values?.via }),
          ...(values?.region && {region_id: values?.region}),
        },
        'arraybuffer', // responseType,
        // {
        //   Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,/;q=0.8,application/signed-exchange;v=b3;q=0.9',
        // },
      );

      if (extension === 'pdf') {
        let nameFile = response.headers['content-disposition'].split('filename=')[1];
        nameFile = nameFile?.replace(/"/g, '');
        fileDownload(response.data, `${nameFile}`);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const onSubmit = async (values, actions) => {
    Object.keys(values).map((item) => {
      if (values[item] && values[item].value) {
        return Object.assign(values, {[item]: values[item].value});
      }
      return true;
    });

    try {
      await fetchData(values);
      actions.setSubmmitting(false);
    } catch (e) {
      console.error(e);
      actions.setSubmitting(false);
    }
  };

  return (
    <>
      {!hasFarms && <Alert type="warning" message="Nenhuma fazenda caracterizada para essa safra." time={4000} />}
      <Card className={`row report-filter filter-container `} style={{transform: 'translateX(0)'}} ref={ref}>
        <div className="col-6 offset-3 filter-content">
          <GenerateForm
            onSubmit={onSubmit}
            groupFields={groupFields}
            settings={{
              button: {
                text: 'Baixar',
                textSubmitting: 'Baixando....',
              },
            }}
          />
        </div>
      </Card>
    </>
  );
};

const SlideOut = keyframes`${slideOutRight}`;
const SlideIn = keyframes`${slideInRight}`;
const Card = styled.div`
  div {
    font-size: 12px;
    font-weight: 200;
  }
  label {
    font-size: 13px;
  }
  button {
    font-size: 14px;
  }
  animation: 1s ${SlideIn};
  &.slideOut {
    animation: 1s ${SlideOut};
  }
`;

export default FilterBenchmarkingDairy;
